<template>
  <v-container fluid>
    <a-form layout="vertical">
      <a-row :gutter="4">
        <a-col :span="24" :xxl="3" :xl="4" :lg="4" :md="8">
          <a-textarea v-model="queryForm.nos" placeholder="派车单号" :auto-size="{ minRows: 6, maxRows: 6 }" />
        </a-col>
        <a-col :span="24" :xxl="21" :xl="20" :lg="20" :md="16">
          <a-row :gutter="4">
            <a-col :span="24" :xxl="2" :xl="3" :lg="3" :md="6">
              <a-form-item label="查询方式">
                <a-select v-model="queryForm.day_type" placeholder="查询方式" :not-found-content="null">
                  <a-select-option key="block_t"> 封车日期 </a-select-option>
                  <a-select-option key="serial_t"> 流水号日期 </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="24" :xxl="4" :xl="6" :lg="6" :md="12">
              <a-form-item label="日期">
                <a-range-picker v-model="queryForm.times" :locale="locale" format="YYYY-MM-DD" valueFormat="YYYY-MM-DD"
                  :allow-clear="false" />
              </a-form-item>
            </a-col>
            <a-col :span="24" :xxl="2" :xl="3" :lg="4" :md="6">
              <a-form-item label="车牌号">
                <a-input v-model="queryForm.vehicle_number" placeholder="车牌号" allow-clear>
                </a-input>
              </a-form-item>
            </a-col>
            <a-col :span="24" :xxl="2" :xl="3" :lg="3" :md="6">
              <a-form-item label="邮路级别">
                <a-select v-model="queryForm.postroutelevel" placeholder="一干/二干" allow-clear>
                  <a-select-option key="一级"> 一干 </a-select-option>
                  <a-select-option key="二级"> 二干 </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="24" :xxl="2" :xl="3" :lg="3" :md="6">
              <a-form-item label="性质">
                <a-select v-model="queryForm.transport_kind" placeholder="单程/往返" allow-clear>
                  <a-select-option key="单程"> 单程 </a-select-option>
                  <a-select-option key="往返"> 往返 </a-select-option>
                  <!-- <a-select-option key="去程"> 去程 </a-select-option>
                  <a-select-option key="返程"> 返程 </a-select-option> -->
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="24" :xxl="2" :xl="3" :lg="3" :md="6">
              <a-form-item label="邮局">
                <a-select v-model="queryForm.postofficeid" :options="postoffices" placeholder="邮局" allow-clear>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="24" :xxl="4" :xl="4" :lg="5" :md="6">
              <a-form-item label="派车响应单位">
                <a-input v-model="queryForm.dispatch_response_corp" placeholder="派车响应单位" allow-clear>
                </a-input>
              </a-form-item>
            </a-col>
            <a-col :span="24" :xxl="3" :xl="4" :lg="3" :md="6">
              <a-form-item label="所属标段">
                <a-select v-model="queryForm.section" :options="sections" placeholder="所属标段" allow-clear>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="24" :xxl="3" :xl="4" :lg="3" :md="6">
              <a-form-item label="车辆归属">
                <a-select v-model="queryForm.own_type" :options="own_types" placeholder="车辆归属" allow-clear>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="24" :xxl="3" :xl="4" :lg="3" :md="6">
              <a-form-item label="所属公司">
                <a-select v-model="queryForm.corp" :options="corps" placeholder="所属公司" allow-clear>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="24" :xxl="4" :xl="4" :lg="5" :md="6">
              <a-form-item label="线路名称">
                <a-input v-model="queryForm.linename" placeholder="线路名称" allow-clear>
                </a-input>
              </a-form-item>
            </a-col>
            <a-col :span="24" :xxl="4" :xl="6" :lg="3" :md="12">
              <div class="d-flex align-end" style="margin-top:15px;height:42px;">
                <a-space>
                  <v-btn @click="getdata" color="primary" dark tile small>
                    <v-icon small>mdi-magnify</v-icon>查询
                  </v-btn>
                  <v-btn tile small v-if="role === 'root'">
                    <a-dropdown>
                      <a class="ant-dropdown-link" @click="e => e.preventDefault()">
                        下载账单
                        <a-icon type="down" />
                      </a>
                      <a-menu slot="overlay" @click="(e) => {
                        downloadbill(e.key);
                      }">
                        <a-menu-item key="1">
                          <a href="javascript:;">下载账单</a>
                        </a-menu-item>
                        <a-menu-item key="2">
                          <a href="javascript:;">下载账单2</a>
                        </a-menu-item>
                        <a-menu-item key="3">
                          <a href="javascript:;">下载账单3</a>
                        </a-menu-item>
                        <a-menu-item key="4">
                          <a href="javascript:;">下载账单4</a>
                        </a-menu-item>
                      </a-menu>
                    </a-dropdown>
                  </v-btn>
                  <v-btn v-else-if="showincomeprofit" @click="downloadbill('1')" color="indigo" dark tile small>
                    <v-icon small>mdi-download</v-icon>下载账单
                  </v-btn>
                </a-space>
              </div>
            </a-col>
          </a-row>
        </a-col>
      </a-row>
    </a-form>
    <p v-if="total" class="text-h6">
      合计：
      <span class="success--text" v-if="showincomeprofit"> 合同收入({{ total.income }}) </span>{{ showincomeprofit ? ',' :
        '' }}
      <span class="error--text"> 运费支出({{ total.cost }}) </span>{{ showincomeprofit ? ',' : '' }}
      <span v-if="showincomeprofit" :class="{ 'success--text': total.profit > 0, 'error--text': total.profit < 0 }">
        公司利润({{ total.fprofit }})
      </span>{{ showincomeprofit ? ',' : '' }}
      <span v-if="showincomeprofit"> 外包收入({{ total.income2 }}) </span>{{ showincomeprofit ? ',' : '' }}
      <span v-if="showincomeprofit"> 外包运费({{ total.F2 }})</span>{{ showincomeprofit ? ',' : '' }}
      <span v-if="showincomeprofit" :class="{ 'success--text': total.profit2 > 0, 'error--text': total.profit2 < 0 }">
        外包利润({{ total.fprofit2 }})
      </span>{{ showincomeprofit ? ',' : '' }}
      <span v-if="showincomeprofit" :class="{ 'success--text': total.profit1 > 0, 'error--text': total.profit1 < 0 }">
        公司利润({{ total.fprofit1 }})
      </span>
    </p>
    <v-card tile>
      <a-table size="small" :columns="headers" :data-source="list" :locale="{ emptyText: '暂无数据' }"
        :scroll="{ x: width, y: height }">
        <template slot="index">
          {{ list.length }}
        </template>
        <template slot="index" slot-scope="text, record">
          {{ record.index }}
        </template>
        <template slot="AH">
          <p style="font-size:12px;">邮局</p>
          <p style="font-size:12px;">所属公司</p>
        </template>
        <template slot="A" slot-scope="text, record">
          <p style="font-size:12px;">{{ record.postoffice }}</p>
          <p style="font-size:12px;">{{ record.corp }}</p>
        </template>
        <template slot="BH">
          <p style="font-size:12px;">邮路名称</p>
          <p style="font-size:12px;">邮路性质</p>
          <p style="font-size:12px;">所属标段</p>
        </template>
        <template slot="B" slot-scope="text, record">
          <p style="font-size:12px;">{{ record.postroute }}</p>
          <p style="font-size:12px;" :class="{
            'primary--text': record.transport_kind === '单程',
            'error--text': record.transport_kind === '往返',
          }">{{ record.transport_kind }}</p>
          <p v-if="record.section" :style="{
            'color': $utils.textToBgColor(record.section.replace('标段', '')),
            'font-size': '12px',
          }">{{ record.section }}</p>
        </template>
        <template slot="CH">
          <p style="font-size:12px;">流水号日期</p>
          <p style="font-size:12px;">封车日期</p>
        </template>
        <template slot="C" slot-scope="text, record">
          <p style="font-size:12px;">{{ record.serial_day }}</p>
          <p style="font-size:12px;">{{ record.block_day }}</p>
        </template>
        <template slot="DH">
          <p style="font-size:12px;">流水号</p>
          <p style="font-size:12px;">派车单号</p>
          <p style="font-size:12px;">车牌号</p>
        </template>
        <template slot="D" slot-scope="text, record">
          <p style="font-size:12px;">{{ record.serial_no }}</p>
          <p style="font-size:12px;">{{ record.dispatch_no }}</p>
          <p style="font-size:12px;">{{ record.vehicle_number }}</p>
        </template>
        <template slot="EH">
          <p style="font-size:12px;">车型</p>
          <p style="font-size:12px;">要求派车吨位</p>
        </template>
        <template slot="E" slot-scope="text, record">
          <p style="font-size:12px;">{{ record.vehicle_type }}</p>
          <p style="font-size:12px;" class="error--text">{{ record.own_type }}</p>
          <p style="font-size:12px;">{{ record.request_weight }}</p>
        </template>
        <template slot="E1H">
          <p style="font-size:12px;">封车时间</p>
          <p style="font-size:12px;">出围栏时间</p>
        </template>
        <template slot="E1" slot-scope="text, record">
          <p style="font-size:12px;">{{ record.block_time || '-' }}</p>
          <p style="font-size:12px;">{{ record.out_time || '-' }}</p>
        </template>
        <template slot="E2H">
          <p style="font-size:12px;">入围栏时间</p>
          <p style="font-size:12px;">入局扫描时间</p>
          <p style="font-size:12px;">解车时间</p>
        </template>
        <template slot="E2" slot-scope="text, record">
          <p style="font-size:12px;">{{ record.in_time || '-' }}</p>
          <p style="font-size:12px;">{{ record.scan_time || '-' }}</p>
          <p style="font-size:12px;">{{ record.unblock_time || '-' }}</p>
        </template>
        <template slot="FH">
          <span style="font-size:12px;" class="success--text">合同收入</span>
        </template>
        <!--合同收入-->
        <template slot="F" slot-scope="text, record">
          <span style="font-size:12px;" class="success--text">
            {{ record.real_oilfreight1 || record.real_freight1 }}
          </span>
        </template>
        <template slot="F1H">
          <p style="font-size:12px;">车辆成本</p>
          <p style="font-size:12px;">司机成本</p>
        </template>
        <!--运费明细(车辆成本，司机成本，电费，油费，过路费)-->
        <template slot="F1" slot-scope="text, record">
          <p style="font-size:12px;">{{ record.vcost }}</p>
          <p style="font-size:12px;">{{ record.dcost }}</p>
        </template>
        <template slot="F2H">
          <p style="font-size:12px;">电费</p>
          <p style="font-size:12px;">油费</p>
          <p style="font-size:12px;">过路费</p>
        </template>
        <template slot="F2" slot-scope="text, record">
          <p style="font-size:12px;">{{ record.ecost }}</p>
          <p style="font-size:12px;">{{ record.ocost }}</p>
          <p style="font-size:12px;">{{ record.rcost }}</p>
        </template>
        <template slot="GH">
          <span style="font-size:12px;" class="error--text">运费支出</span>
        </template>
        <!--运费支出(下游运费，自营调车运费，外包合同价)-->
        <template slot="G" slot-scope="text, record">
          <p v-if="record.out_freight > 0" class="error--text" style="font-size:12px;">
            {{ record.out_freight }}
          </p>
          <p v-else-if="record.real_freight2_947 > 0" class="error--text" style="font-size:12px;">
            {{ record.real_freight2_947 }}
          </p>
          <p v-else class="error--text" style="font-size:12px;">
            {{ record.real_freight2 }}
          </p>
        </template>
        <template slot="HH">
          <span style="font-size:12px;">公司利润</span>
        </template>
        <!--公司利润-->
        <template slot="H" slot-scope="text, record">
          <span style="font-size:12px;" :class="{
            'font-weight-bold': true,
            'error--text': record.profit < 0,
            'success--text': record.profit > 0
          }">
            {{ record.profit }}
          </span>
        </template>
        <template slot="IH">
          <span style="font-size:12px;">外包收入</span>
        </template>
        <!--外包收入-->
        <template slot="I" slot-scope="text, record">
          <span v-if="record.out_freight > 0" style="font-size:12px;">
            {{ record.out_freight }}
          </span>
        </template>
        <template slot="JH">
          <span style="font-size:12px;">外包运费</span>
        </template>
        <!--外包运费-->
        <template slot="J" slot-scope="text, record">
          <span v-if="record.out_freight > 0" style="font-size:12px;">
            {{ record.real_freight2_947 }}
          </span>
        </template>
        <template slot="KH">
          <span style="font-size:12px;">外包利润</span>
        </template>
        <!--外包利润-->
        <template slot="K" slot-scope="text, record">
          <span style="font-size:12px;" :class="{
            'font-weight-bold': true,
            'success--text': record.profit2 > 0,
            'error--text': record.profit2 < 0
          }">
            {{ record.profit2 }}
          </span>
        </template>
      </a-table>
    </v-card>
  </v-container>
</template>

<script>
import _ from "underscore";
import locale from 'ant-design-vue/es/date-picker/locale/zh_CN';
import { mapState } from "vuex";
export default {
  name: "FinanceFinancialBill",
  data() {
    return {
      locale,
      queryForm: {
        nos: "",
        day_type: "block_t",
        times: [null, null],
        province: "",
        vehicle_number: "",
        postroutelevel: undefined,
        transport_kind: undefined,
        postofficeid: undefined,
        postlineids: [],
        dispatch_response_corp: '',
        section: undefined,
        own_type: undefined,
        corp: undefined,
        linename: "",
      },
      provinces: [],
      corps: [],
      postoffices: [],
      postlines: [],
      sections: [],
      own_types: [],
      list: [],
      height: 600,
      vrules: {
        required: (value) => !!value || "不能为空"
      },
      showincomeprofit: false,
    };
  },
  computed: {
    ...mapState(["role", "username"]),
    headers() {
      return [
        { dataIndex: "index", slots: { title: "index" }, scopedSlots: { customRender: "index" }, width: 80, align: "center", fixed: "left" },
        { dataIndex: "A", slots: { title: "AH" }, scopedSlots: { customRender: "A" }, width: 100, align: "center", fixed: "left" },
        { dataIndex: "B", slots: { title: "BH" }, scopedSlots: { customRender: "B" }, width: 100, align: "center", fixed: "left" },
        { dataIndex: "C", slots: { title: "CH" }, scopedSlots: { customRender: "C" }, width: 100, align: "center", fixed: "left" },
        { dataIndex: "D", slots: { title: "DH" }, scopedSlots: { customRender: "D" }, width: 100, align: "center", fixed: "left" },
        { dataIndex: "E", slots: { title: "EH" }, scopedSlots: { customRender: "E" }, width: 100, align: "center", fixed: "left" },
        { dataIndex: "E1", slots: { title: "E1H" }, scopedSlots: { customRender: "E1" }, width: 128, align: "center" },
        { dataIndex: "E2", slots: { title: "E2H" }, scopedSlots: { customRender: "E2" }, width: 128, align: "center" },
        ...(this.showincomeprofit ? [
          { dataIndex: "F", slots: { title: "FH" }, scopedSlots: { customRender: "F" }, width: 100, align: "center" },
        ] : []),
        { dataIndex: "F1", slots: { title: "F1H" }, scopedSlots: { customRender: "F1" }, width: 100, align: "center" },
        { dataIndex: "F2", slots: { title: "F2H" }, scopedSlots: { customRender: "F2" }, width: 100, align: "center" },
        { dataIndex: "G", slots: { title: "GH" }, scopedSlots: { customRender: "G" }, width: 100, align: "center" },
        ...(this.showincomeprofit ? [
          { dataIndex: "H", slots: { title: "HH" }, scopedSlots: { customRender: "H" }, width: 100, align: "center" },
        ] : []),
        ...(this.showincomeprofit ? [
          { dataIndex: "I", slots: { title: "IH" }, scopedSlots: { customRender: "I" }, width: 100, align: "center" },
        ] : []),
        ...(this.showincomeprofit ? [
          { dataIndex: "J", slots: { title: "JH" }, scopedSlots: { customRender: "J" }, width: 100, align: "center" },
          { dataIndex: "K", slots: { title: "KH" }, scopedSlots: { customRender: "K" }, width: 100, align: "center" },
        ] : []),
      ];
    },
    width() {
      return _.reduce(this.headers, (a, b) => a + (b.width || 300), 0);
    },
    selectAllPostline() {
      return this.queryForm.postlineids.length === this.postlines.length
    },
    selectSomePostline() {
      return this.queryForm.postlineids.length > 0 && !this.selectAllPostline;
    },
    icon() {
      if (this.selectAllPostline) return 'mdi-close-box'
      if (this.selectSomePostline) return 'mdi-minus-box'
      return 'mdi-checkbox-blank-outline'
    },
    total() {
      let total = {
        income: this.$d(),//合同收入
        cost: this.$d(),//运费支出
        profit: this.$d(),//公司利润
        profit1: this.$d(),//公司利润(外包)
        fprofit: '',
        fprofit1: '',
        income2: this.$d(),//外包收入
        F2: this.$d(),//外包运费
        profit2: this.$d(),//外包利润
        fprofit2: '',
      };
      for (let i = 0; i < this.list.length; i++) {
        let {
          real_freight1,
          real_oilfreight1,
          out_freight,
          real_freight2,
          real_freight2_947,
          profit,
          profit2,
        } = this.list[i];
        let cost = 0;
        if (out_freight > 0) cost = out_freight;
        else cost = real_freight2_947 || real_freight2 || 0;
        total.income = total.income.plus(real_oilfreight1 || real_freight1 || 0);
        total.cost = total.cost.plus(cost);
        if (out_freight > 0) {
          total.income2 = total.income2.plus(out_freight);
          total.F2 = total.F2.plus(real_freight2_947 || 0);
          total.profit1 = total.profit1.plus(profit);
        }
        total.profit = total.profit.plus(profit);
        total.profit2 = total.profit2.plus(profit2 || 0);
      }
      total.fprofit = this.$utils.formatMoney(total.profit.toString(), 2, '');
      total.fprofit1 = this.$utils.formatMoney(total.profit1.toString(), 2, '');
      total.fprofit2 = this.$utils.formatMoney(total.profit2.toString(), 2, '');
      total.income = this.$utils.formatMoney(total.income.toString(), 2, '');
      total.cost = this.$utils.formatMoney(total.cost.toString(), 2, '');
      total.income2 = this.$utils.formatMoney(total.income2.toString(), 2, '');
      total.F2 = this.$utils.formatMoney(total.F2.toString(), 2, '');
      return total;
    },
  },
  components: {},
  watch: {
  },
  mounted() {
    this.height = window.innerHeight - 380;
    window.onresize = (e) => {
      console.log("onresize", window.innerHeight);
      this.height = window.innerHeight - 380;
    };
    this.list = [];
    let start_day = this.$dayjs().subtract(1, 'day').format("YYYY-MM-DD");
    let end_day = this.$dayjs().format("YYYY-MM-DD");
    this.queryForm = {
      nos: "",
      day_type: "block_t",
      times: [start_day, end_day],
      province: "",
      vehicle_number: "",
      postroutelevel: undefined,
      transport_kind: undefined,
      postofficeid: undefined,
      postlineids: [],
      dispatch_response_corp: '',
      section: undefined,
      own_type: undefined,
      corp: undefined,
      linename: "",
    };
    this.getdata();
  },
  methods: {
    getdata() {
      this.$toast.loading({ message: "" });
      this.$api.doAPI("/financialbill/list", { ...this.queryForm }).then((res) => {
        this.$toast.clear();
        if (res.code === 0) {
          this.list = res.data.list.map((n, i) => {
            return {
              ...n,
              index: i + 1,
            };
          });
          this.provinces = res.data.provinces;
          this.postoffices = res.data.postoffices;
          this.postlines = res.data.postlines;
          this.corps = res.data.corps;
          this.sections = res.data.sections;
          this.own_types = res.data.own_types;
          this.showincomeprofit = res.data.showincomeprofit;
        } else {
          this.$alert(res.msg);
        }
      }).catch((err) => {
        this.$toast.clear();
        console.error(err);
      });
    },
    downloadbill(format) {
      this.$toast.loading({ message: "" });
      this.$api.doAPI("/financialbill/list", { ...this.queryForm, action: 'download', format }).then((res) => {
        this.$toast.clear();
        if (res.code === 0) {
          this.$download(res.data.url, res.data.name);
        } else {
          this.$alert(res.msg);
        }
      }).catch((err) => {
        this.$toast.clear();
        console.error(err);
      });
    },
    toggle() {
      this.$nextTick(() => {
        if (this.selectAllPostline) {
          this.queryForm.postlineids = []
        } else {
          this.queryForm.postlineids = _.pluck(this.postlines, "value");
        }
      })
    },
    getpostoffice(item) {
      return _.findWhere(this.postoffices, { value: item.postofficeid })?.label;
    }
  },
};
</script>
<style lang="less" scoped>
/deep/ .ant-form-item {
  margin-bottom: unset;
}

/deep/ .row {
  margin-bottom: 0 !important;
}

/deep/ .row+.row {
  margin-top: 0;
}

/deep/ .col,
.col-12 {
  padding-bottom: 0 !important;
}

/deep/ .ant-table-fixed-header .ant-table-scroll .ant-table-header {
  padding-bottom: 4px !important;
}

/deep/ .ant-table-small>.ant-table-content>.ant-table-fixed-left>.ant-table-header>table>.ant-table-thead>tr>th {
  padding: 0 !important;
}

/deep/ .ant-table-small>.ant-table-content>.ant-table-fixed-left>.ant-table-body-outer>.ant-table-body-inner>table>.ant-table-tbody>tr>td {
  padding: 0 !important;
}

/deep/ .ant-table-small>.ant-table-content>.ant-table-scroll>.ant-table-header>table>.ant-table-thead>tr>th {
  padding: 0 !important;
}

/deep/ .ant-table-small>.ant-table-content>.ant-table-scroll>.ant-table-body>table>.ant-table-tbody>tr>td {
  padding: 0 !important;
}

p {
  margin: 0;
}
</style>
